import { createFileRoute } from "@tanstack/react-router";

import { PayoutPage } from "@/features/money/pages";

export const Route = createFileRoute("/_app/money/payouts/$payoutId")({
  component: Payout,
});

function Payout() {
  const { payoutId } = Route.useParams();
  return <PayoutPage key={payoutId} payoutId={payoutId} />;
}
